<template>
    <div class="title-block">
        <div class="title-block__left">
            <div class="title-block__title">Реестр релизов</div>
            <a :href="route_create_page" class="title-block__btn btn-add btn-primary btn">Добавить</a>
        </div>
	</div>
	<div class="log-schedule-update-component">
		<div class="log-schedule-update-component-table-ctrls mb-4">
			<div class="filter-table__input-wrap search-control">
				<input @keyup.enter="onSearch()" @keyup.delete="onDeleteSearch()" type="text" v-model="search" class="search-control__input form-control" placeholder="Поиск по описанию или версии">
				<button @click="onSearch()" class="search-control__input-btn reset-btn">
					<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z" fill="currentColor"></path>
					</svg>
				</button>
			</div>

            <filter-component :filters="filter" @filterApplied="handleFilterData" />
		</div>

		<table class="service-table table align-middle">
			<thead>
				<tr>
					<th class="col-header" scope="col" v-for="(elem, index) in thead" :key="index">
						<div style="display: flex; gap: 4px; align-items: center; justify-content: center;" class="th-inner sortable asc">
							<span style="width: 95%;">{{ elem }}</span>
							<div class="dropdown">
								<svg v-if="['Тип устройства', 'Версия', 'Дата релиза', 'ОС'].includes(elem)" @click="toggleDropdown(index)"
									style="cursor: pointer;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M5 7.5L10 12.5L15 7.5" stroke="#575F6E" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<div class="dropdown-menu" :class="{ 'show': dropdownVisible[index] }">
									<a class="dropdown-item" href="#" @click.prevent="sortBy('asc', elem)">По возрастанию</a>
									<a class="dropdown-item" href="#" @click.prevent="sortBy('desc', elem)">По убыванию</a>
								</div>
							</div>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="row in tbody" :key="row.id">
					<td>{{ row.tbody.device_type }}</td>
                    <td>{{ row.tbody.release_type }}</td>
					<td>{{ row.tbody.version_number }}</td>
                    <td>{{ row.tbody.release_scheduled_date }}</td>
                    <td>
                        <div class="devices-status">
                            <a class="devices-status__info" :href="this.getUrlAssignmentPage(row.id, 'all')">
                                <img class="status-icon" src="/images/status-icon-all.svg">
                                <span>{{ this.getTotalDeviceAssignments(row.tbody.status_device_assignments) }}</span>
                            </a>
                            <template v-for="status in row.tbody.status_device_assignments" :key="status.code">
                                <a v-if="status.count > 0"
                                   :href="getUrlAssignmentPage(row.id, status.code)"
                                   class="devices-status__info active"
                                >
                                    <img class="status-icon" :src="mapStatusIcons(status.code)" :alt="status.name">
                                    <span>{{ status.count }}</span>
                                </a>
                                <div v-else class="devices-status__info disabled" title="Нет устройств">
                                    <img class="status-icon" :src="mapStatusIcons(status.code)" :alt="status.name">
                                    <span>{{ status.count }}</span>
                                </div>
                            </template>
                        </div>
                    </td>
                    <td>{{ row.tbody.device_os }}</td>
                    <td class="text-xl-center"><input class="form-check-input" type="checkbox" :checked="row.tbody.is_emergency_release" disabled></td>
                    <td ref="description">{{ row.tbody.description }}</td>
                    <td>{{ row.tbody.brand }}</td>
                    <td>{{ row.tbody.client }}</td>
					<td>
                        <div class="table-action-buttons">
                            <a @click="setReleaseInfo(row)"
                                @auxclick="setReleaseInfo(row)"
                                @contextmenu="setReleaseInfo(row)"
                                :href="route_logs" class="table-action table-action_log m-auto align-middle" title="Просмотр логов"></a>
							<button v-if="row.tbody.access_edit" @click="editRelease(row.id)" class="table-action table-action_edit m-auto align-middle" title="Редактировать"></button>
							<button v-if="row.tbody.access_edit" @click="destroyRelease(row.id)" class="table-action table-action_delete m-auto align-middle" title="Удалить"></button>
						</div>
                    </td>
				</tr>
			</tbody>
		</table>
	</div>

    <pagination-element :count="count" :current_page="page" @pageChange="pageChange"></pagination-element>
</template>

<script>
import Release from '../../../../models/Release';
import ChangePage from '../../../../helpers/ChangePage';
import PaginationElement from '../../../../elements/PaginationElement.vue';
import { mapMutations, version } from 'vuex/dist/vuex.cjs.js';
import DeviceQuantityModal from '../../../../modals/DeviceQuantityModal.vue';
import { dateFormat } from '../../../../utilites';

import { mapState } from 'vuex/dist/vuex.cjs.js';
import { nextTick } from 'vue';
import axios from "axios";

export default {
    name: 'ReleaseRegistryComponent',
    props: {
        route_index: String,
        route_list: String,
        route_edit: String,
        route_delete: String,
        route_create_page: String,
        route_brands_list: String,
        route_get_names_devices_types: String,
        route_logs: String,
        // route_versions: String,
        route_version_options: String,
        route_clients: String,
        // route_devices_software: String,
        route_operating_systems: String,
        route_destroy_release: String,
        route_assigment_page: String,
        current_page: {
            type: Number,
            default: 1
        },
    },
    components: {
        DeviceQuantityModal,
        PaginationElement,
	},

    emits: ['closeModal'],

	data() {
		return {
            release: new Release({
                route_list: this.route_index,
                route_delete: this.route_delete,
                // route_devices_software: this.route_devices_software,
                route_client_search: this.route_clients,
            }),
			brand: null,
			brands: [],
            selectedBrand: null,

			client: null,
			clients: [],
            selectedClient: null,

			deviceType: null,
			deviceTypes: [],
            devicesModal: false,
            devices: [],
            selectedDeviceType: null,

            deviceOperatingSystem: null,
            deviceOperatingSystems: [],
            selectedDeviceOperatingSystem: null,

            version: null,
            versions: [],
            selectedVersion: null,

            date: null,

            search: null,

            lengthDescriptionCharacterSlice: 80,

			thead: [
                'Тип устройства',
                'Тип релиза',
                'Версия',
                'Дата релиза',
                'Количество устройств',
                'ОС',
                'Внеочередное обновление',
                'Описание',
                'Бренд',
                'Клиент',
                'Действия'
            ],

			tbody: [],
            columnMap: {
                'Дата релиза': 'scheduled_release_date',
                'Статус': 'status_id',
                'Версия': 'device_software_version_id',
                'Тип устройства': 'device_type_id',
                'ОС': 'device_operating_system_id'
            },
			currentSortColumn: '',
			currentSortOrder: '',
			dropdownVisible: Array(9).fill(false),

			selectedRows: [],
			selectAll: false,

            count: 1,
            limit: 30,
            page: 1,

            statusDeviceAssignments: null
		}
	},

    computed: {
        ...mapState('filterComponent', ['filterState']),

        filter() {
            return [
                {
					type: 'select',
					name: 'Клиент',
					model: this.client,
					options: this.clients
				},
				{
					type: 'select',
					name: 'Бренд',
					model: this.brand,
					options: this.brands
				},
				{
					type: 'select',
					name: 'Тип устройства',
					model: this.deviceType,
					options: this.deviceTypes
				},
				{
					type: 'select',
					name: 'Версия',
					model: this.version,
					options: this.versions
				},
                {
					type: 'select',
					name: 'ОС',
					model: this.deviceOperatingSystem,
					options: this.deviceOperatingSystems
				},
				{
					type: 'date',
					name: 'Дата',
					model: null,
				},
            ]
        }
    },

	methods: {
        dateFormat,
        ...mapMutations('logs', ['setReleaseInfo']),
        sortBy(order, column) {
			this.currentSortColumn = this.columnMap[column];
			this.currentSortOrder = order;
			this.loadTable();
		},
        getTotalDeviceAssignments: function(assignments) {
            let count = 0;
            assignments.forEach(assignment => {
                count += assignment.count;
            });
            return count;
        },
        getUrlAssignmentPage: function (releaseId, filter) {
            return this.route_assigment_page
                .replace('release_id', releaseId)
                .replace('filter', filter)
        },
        showDevicesModal(devices) {
            this.devicesModal = true;
            this.devices = devices;
        },
        loadTable: async function () {
            let response = await this.release.loadTable(
                this.page,
                this.limit,
                this.search,
                this.selectedClient,
                this.selectedBrand,
                this.selectedDeviceType,
                this.selectedDeviceOperatingSystem,
                this.selectedVersion,
                this.date,
                this.currentSortColumn,
                this.currentSortOrder
            );
            this.tbody = response.tbody;

            this.$nextTick(() => {
                this.checkDescriptionLength();
            })

            this.count = response.pages;
            if (this.page > 1 && this.tbody.length === 0) {
                this.page = 1;
                ChangePage(this.page, false);
                await this.loadTable();
            }
        },
		toggleDropdown: function (index) {
            setTimeout(() => {
                this.dropdownVisible = this.dropdownVisible.map((visible, i) => (i === index ? !visible : false));
            }, 1)
        },

        closeDropdown(event) {
            let clickOutside = event.target.className !== 'dropdown-item';
            let dropDownOpenned = document.querySelector('.show') !== null;
            if (dropDownOpenned && clickOutside) {
                this.dropdownVisible = this.dropdownVisible.map(() => false);
            }
        },

		toggleSelectAll() {
			if (this.selectAll) {
				this.selectedRows = this.tbody.map(row => row.id);
			} else {
				this.selectedRows = [];
			}
		},
        showHistoryModal() {
			this.historyModal = true;
		},
        closeDevicesModal() {
            this.devicesModal = false;
        },
		closeHistoryModal() {
			this.historyModal = false;
		},
        getBrands: async function () {
            let data = await axios.get(this.route_brands_list);
            this.brands = data.data.items;
        },
        getDevicesTypesName: async function () {
            let data = await axios.get(this.route_get_names_devices_types);
            let deviceTypesData = data.data;

            for (const key in deviceTypesData) {
                this.deviceTypes[key] = {
                    id: deviceTypesData[key].id,
                    name: deviceTypesData[key].name
                }
            }
        },
        getDeviceOperatingSystems: async function () {
            const response = await axios.get(this.route_operating_systems);
            this.deviceOperatingSystems = response.data.data;
        },
        getClients: async function () {
            let clients = await this.release.clients();
            this.clients = clients.items;
        },
        getVersionOptions: async function() {
            const response = await axios.get(this.route_version_options);
            this.versions = response.data.data;
        },
        onSearch: async function () {
            this.page = 1;
            await this.loadTable()
        },
        onDeleteSearch: async function () {
            if (this.search.trim() === '') {
                this.page = 1;
                await this.loadTable()
            }
        },
        pageChange: async function (page) {
            this.page = page;
            await this.loadTable();
        },
        editRelease: async function (id) {
            location.href = this.route_edit + id
        },
        handleFilterData(data) {
            this.selectedClient = data.selectedClient ?? null;
            this.selectedBrand = data.selectedBrand ?? null;
            this.selectedDeviceType = data.selectedDeviceType ?? null;
            this.selectedVersion = data.selectedVersion ?? null;
            this.selectedDeviceOperatingSystem = data.selectedDeviceOperatingSystem ?? null;
            this.date = data.date ?? null;

            this.loadTable();
        },
        checkDescriptionLength() {
            const cells = this.$refs.description;
            if (!!cells) {
                cells.forEach(cell => {
                    if (cell.innerText.length >= this.lengthDescriptionCharacterSlice) {
                        cell.title = cell.innerText;
                        cell.innerText = cell.innerText.slice(0, this.lengthDescriptionCharacterSlice) + "…";
                        cell.style.cursor = 'help';
                    }
                });
            }
        },
        mapStatusIcons(statusId) {
            const iconsMap = {
                'scheduled':'/images/status-icon-planned.svg',
                'downloaded': '/images/status-icon-downloaded.svg',
                'installed': '/images/status-icon-installed.svg',
                'failed': '/images/status-icon-error.svg',
            };
            return iconsMap[statusId];
        },
        destroyRelease: async function(id) {
            let confirmDestroy = confirm('Вы уверены что хотите удалить запись?');

            if(!confirmDestroy) {
                return;
            }

            if (confirmDestroy) {
                await axios.delete(`${this.route_index}/${id}`).then(this.loadTable)
            }
        },
	},
	mounted() {
        this.loadTable();
        this.getClients();
        this.getBrands();
        this.getDevicesTypesName();
        this.getDeviceOperatingSystems();
        this.getVersionOptions();
	}
}
</script>

<style scoped lang="scss">
	.title-block {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
        align-items: center;
        &__btns {
			display: flex;
            margin: 0px;
            justify-content: space-between;
            width: 100%;
        }
	}

	.page-label {
		font-size: 18px;
		font-weight: 600;
	}

	.log-schedule-update-component-table-ctrls {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 20px;
	}

	.v-selects {
		display: flex;
		flex-direction: row;
		gap: 20px;
	}

	.dropdown {
        position: relative;
        display: inline-block;
    }

    .dropdown-item {
        font-size: 14px;
    }

    .dropdown-menu {
        padding: 0;
        position: absolute;
        min-width: 160px;
        border-radius: 5px;
        border: none;
        box-shadow: 0px 4px 16px 0px rgba(100, 100, 100, 0.2);
        z-index: 1;
    }

    .dropdown-menu a {
        color: black;
        padding: 8px 12px;
        text-decoration: none;
        display: block;
    }

    .dropdown-menu a:hover {
        background-color: #F1F7FF;
    }

    .table-action-buttons {
        display: flex;
        gap: 8px;
    }

	.col-header {
		font-size: 14px;
		font-weight: 600;
		color: #575F6E;
	}

	.table-popup {
		&__btn {
			display: flex;
			gap: 6px;
			background-color: #F1F6FF;
			border-radius: 4px;
			padding: 4px 6px;
			cursor: pointer;
		}
		&__check {
			@extend .table-popup__btn;
			background-color: white;
			cursor: default;
		}
	}

    .devices-status {
        min-width: 200px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        &__info {
            padding: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 4px;
            text-decoration: none;
            color: black;
            border-radius: 6px;
            transition: 0.15s;
            &:hover {
                background-color: #F1F6FF;
                transition: 0.15s;
            }
        }
    }
    .devices-status__info {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 4px 8px;
        border-radius: 4px;
    }

    .devices-status__info.active {
        cursor: pointer;
    }

    .devices-status__info.active:hover {
        background: #f8f9fa;
    }

    .devices-status__info.disabled {
        opacity: 0.6;
    }
</style>
